/* Copyright (c) 2018 Verge Technologies
 * @file App.js
 * @author Brenton Watt <brenton@verge.co.za>
 */
import React from 'react';
import 'babel-polyfill';
import Routes from './routes';
import './App.css';

const App = (props) => (
  <Routes client={props.client} />
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js